import React from 'react';
import { Box, Typography, Avatar, Container, Paper } from '@mui/material';
// import Camera  from './Dashboard/Camera'
// import BatteryStatus from './Dashboard/BatteryStatus'
const Profile = ({adminData}) => {


    return (
        <Container maxWidth="md" sx={{ mt: 5 }}> 
            <Box textAlign="center" mb={4}>
            <Avatar alt="Admin Photo"
                    src="admin-photo.jpg"
                    sx={{ width: 120, height: 120, margin: 'auto' }}>{adminData.organizationName.split('')[0]}</Avatar>
                <Typography variant="h4" sx={{ mt: 2 }}>
                    {adminData.adminFirstName} {adminData.adminLastName}
                </Typography>
                <Typography variant="h6" color="text.secondary">
                    {adminData.organizationName}
                 
                </Typography>
            </Box>

            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Contact Information
                </Typography>
                <Typography>
                    <strong>Email:</strong> <a href={`mailto:${adminData.adminEmail}`}>{adminData.adminEmail}</a>
                </Typography>
                <Typography>
                    <strong>Phone:</strong> {adminData.phoneNumber}
                </Typography>
            </Paper>

            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Address
                </Typography>
                <Typography>
                    <strong>Street:</strong> {adminData.address.street}
                </Typography>
                <Typography>
                    <strong>City:</strong> {adminData.address.city}
                </Typography>
                <Typography>
                    <strong>State:</strong> {adminData.address.state}
                </Typography>
                <Typography>
                    <strong>Country:</strong> {adminData.address.country}
                </Typography>
                <Typography>
                    <strong>ZIP Code:</strong> {adminData.address.zip}
                </Typography>
            </Paper>

            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Account Created On
                </Typography>
                <Typography>
                    {new Date(adminData.createdAt).toLocaleString()}
                </Typography>
            </Paper>
        </Container>
    );
};

export default Profile;
